const DeliveryMethodsSummaryMethodSentenceSplitter = () => {
  return (
    <span>&nbsp;&bull;&nbsp;</span>
  )
}

export default DeliveryMethodsSummaryMethodSentenceSplitter
